export type CvFormStep =
  | 'import'
  | 'personal'
  | 'common'
  | 'tech'
  | 'experience'
  | 'community'
  | 'education'
  | 'preferences'
  | 'search';

export const usualCVFormSteps: CvFormStep[] = [
  'personal',
  'common',
  'tech',
  'community',
  'preferences',
  'experience',
  'education',
  'search',
];

export const getCvFormSteps = (showImport: boolean): CvFormStep[] =>
  showImport ? ['import', ...usualCVFormSteps] : usualCVFormSteps;

export const getNextCvFormStepByIndex = (index: number, showImport: boolean): CvFormStep | undefined => {
  const cvFormSteps = getCvFormSteps(showImport);
  if (index >= 0 && index < cvFormSteps.length - 1) {
    return cvFormSteps[index + 1];
  }

  return undefined;
};
